"use strict";
exports.__esModule = true;
exports.SvgFileAttachmentsEgnyte = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFileAttachmentsEgnyte = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "#9D2235", d: "M14.127 12.595l4.571 3.429-1.008 1.391-4.572-3.428 1.009-1.392zm-8.477 0l1.009 1.392-4.572 3.428-1.008-1.391 4.571-3.43zM10.75 0v5.779h-1.7V0h1.7z" }),
        react_1["default"].createElement("path", { fill: "#00968F", d: "M9.889 8.352L3.802 3.788.938 5.936l7.244 5.431.018.024v8.539h3.397v-8.564l7.243-5.43-2.86-2.152z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=FileAttachmentsEgnyte.js.map